/* eslint-disable comma-dangle */
/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';

export const LanguageX = styled.div`
  z-index: 999;
  position: fixed;
  top: 0;
  right: 54px;
`;

export const LanguageSelectedButtonContainer = styled.button`
  background-color: #ffffff;
  max-width: 100px;
  max-height: 40px;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  text-transform: uppercase;
  color: #3c3c3b;
  & a {
    color: #3c3c3b;
  }
`;

export const LanguageOptionButtonContainer = styled(
  LanguageSelectedButtonContainer,
).withConfig({
  shouldForwardProp: (prop) => prop !== 'isDropdownOpen',
})`
  display: ${({ isDropdownOpen }) => (isDropdownOpen ? 'flex' : 'none')};
`;

export const LanguageButtonContainer = styled.div`
  display: flex;
  flex-flow: column;
`;

export const LanguageText = styled.span`
  min-width: 25px;
  margin: 0 8px 0 5px;
  font-family: 'DM-Sans';
`;

export const CaretImage = styled.img.withConfig({
  shouldForwardProp: (prop) => prop !== 'isDropdownOpen',
})`
  transform: ${({ isDropdownOpen }) =>
    isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`;
